module.exports = __webpack_public_path__ + "img/suit-11.f915afc9.png";